import { Outlet } from 'react-router'
import { BreadcrumbObjectType } from '~/common/generated/apollo-operations'
import { lazy } from '~/router/lazy'
import { RouteObject } from '~/router/types'

export const workflowRoute: RouteObject = {
  path: 'workflows',
  Component: Outlet,
  handle: { group: 'workflows' },
  children: [
    {
      index: true,
      lazy: lazy(() => import('./WorkflowList')),
      handle: { crumb: 'title_bar.workflows' },
    },
    {
      path: ':workflow_id',
      lazy: lazy(() => import('./details/WorkflowChart')),
      handle: {
        pageType: 'workflow',
        showBackLink: true,
        objectType: BreadcrumbObjectType.WORKFLOW,
      },
    },
  ],
}
